export default {
  batch: {
    status: "Statut",
    totalDistance: "Distance totale (km)",
    productionEmission: "Émission de production (kg CO2e)",
    transportEmission: "Émission de transport (kg CO2e)",
    totalEmission: "Émission totale (kg CO2e)",
    tax: "Taxe (€)",
    more: "Plus",
    fallbackDistanceWarning:
      "Distance calculée selon une méthode de secours, peut contenir des erreurs",
  },
  label: {
    start: "Départ",
    end: "Arrivée",
    via: "Via",
    mode: "Mode de transport",
    weight: "Poids",
    cnCode: "Code NC",
  },
  placeholder: {
    start: "ex. Shanghai, Chine",
    end: "ex. Rotterdam, Pays-Bas",
    via: "ex. Singapour, SG",
    mode: "Mode de transport",
    weight: "Saisir le poids",
    cnCode: "ex. 25070080 ou ciment",
    location: "ex. Shanghai, Chine",
  },
  action: {
    addVia: "Ajouter un point intermédiaire",
    remove: "Supprimer",
    calculate: "Calculer",
    loadMore: "Charger plus",
  },
  transport: {
    sea: "Mer",
    road: "Route",
    rail: "Rail",
    barge: "Péniche",
  },
  unit: {
    tonne: "Tonne",
    kilogram: "Kilogramme",
    pound: "Livre",
  },
  leg: {
    enable_detailed_mode:
      "Activer le mode détaillé pour afficher les valeurs des facteurs d'émission",
    detailed_mode: "Mode détaillé",
    simple_mode: "Mode simple",
    origin: "Origine",
    destination: "Destination",
    transport_mode: "Mode de transport",
    distance: "Distance (km)",
    weight: "Poids (t)",
    cn_code: "Code NC",
    transport_emission: "Émission de transport (kg CO2e)",
    transport_emission_factor: "Facteur d'émission de transport",
    transport_emission_factor_id: "ID du facteur d'émission de transport",
    production_emission: "Émission de production (kg CO2e)",
    production_emission_factor: "Facteur d'émission de production",
    production_emission_factor_id: "ID du facteur d'émission de production",
    total_emission: "Émission totale (kg CO2e)",
  },
  error: {
    cnCodeSearchFailed: "Échec de la recherche du code NC",
    cnCodeSearchFailedDesc:
      "Impossible d'interroger les codes NC disponibles, veuillez vérifier le réseau.",
    locationRequired: "Veuillez saisir un lieu",
    modeRequired: "Veuillez sélectionner un mode de transport",
    requiredFields: "Veuillez remplir tous les champs obligatoires",
    calculationFailed: "Échec du calcul",
    checkInputs: "Veuillez vérifier les saisies ou réessayer ultérieurement",
    cnCodeRequired: "Veuillez saisir le code NC",
    weightRequired: "Veuillez saisir le poids",
    maxViaPoints: "Maximum 3 points intermédiaires autorisés",
    cnCodeInvalid:
      "Le code NC ne peut contenir que des lettres, chiffres et tirets bas, max 20 caractères",
    weightPositive: "Le poids doit être positif",
    locationSearchFailed: "Échec de la recherche de lieu",
    locationSearchFailedDesc:
      "Impossible de se connecter au service de localisation, veuillez réessayer ultérieurement.",
  },
  result: {
    title: "Résultat du calcul",
    selected: "Option sélectionnée",
    alternative: "Option recommandée ({mode})",
    leg: "Segment {index}",
    totalDistance: "Distance totale",
    productionEmission: "Émission de production",
    transportEmission: "Émission de transport",
    totalEmission: "Émission totale",
    tax: "Taxe carbone",
  },
  page: {
    title: "Calculateur d'émissions CBAM",
    single: "Calcul unique",
    batchTitle: "Calcul groupé",
    batch: {
      rowNumber: "Ligne",
      cnCode: "Code NC",
      weight: "Poids (t)",
      originCity: "Ville d'origine",
      originCoords: "Coordonnées d'origine",
      destinationCity: "Ville de destination",
      destinationCoords: "Coordonnées de destination",
      transportMode: "Mode de transport",
      error: "Erreur",
      errorRowsDetected:
        "{count} lignes erronées détectées, automatiquement exclues. Seules {validCount} lignes valides sauvegardées.",
      errors: {
        invalidCsvHeader: "En-tête CSV invalide",
        headerMustBe: "L'en-tête doit être exactement : {fields}",
        batchSizeExceed: "La taille du lot ne peut dépasser {maxSize}",
        csvValidationFailed: "Échec de la validation CSV",
        checkFormat: "Vérifiez le format ou réessayez",
        invalidXlsxFile: "Fichier XLSX invalide",
        fileIsEmpty: "Le fichier est vide",
        invalidXlsxHeader: "En-tête XLSX invalide",
        xlsxValidationFailed: "Échec de la validation XLSX",
      },
    },
    upgradeTip:
      "Passez à la version Pro pour débloquer le calcul du poids segmenté et du code NC afin d'améliorer la précision de la conformité CBAM !",
    learnMore: "En savoir plus",
    reportTitle: "Rapport d'émission",
    viewReport: "Afficher le rapport",
    totalOverview: "Aperçu général",
    origin: "Origine",
    destination: "Destination",
    totalDistance: "Distance totale",
    tax: "Taxe",
    basedOnEUR: "Basé sur €{amount}",
    productionEmission: "Émission de production",
    transportEmission: "Émission de transport",
    totalEmission: "Émission totale",
    pleaseCalculateFirst: "Veuillez d'abord effectuer le calcul",
    batchLimitInfo:
      "Les utilisateurs gratuits prennent en charge jusqu'à 10 enregistrements, les utilisateurs payants jusqu'à 200 enregistrements.",
    clearErrorData: "Effacer les données erronées",
    submitCalculation: "Soumettre le calcul",
    confirmDeleteTask: "Êtes-vous sûr de vouloir supprimer cette tâche ?",
    reupload: "Recharger",
    uploadHint: "Cliquez ou faites glisser le fichier vers cette zone pour le télécharger",
    csvOnlyHint:
      "La version gratuite ne prend en charge que les fichiers csv, les utilisateurs payants prennent en charge les fichiers csv et xlsx",
    configFailed: "Échec de l'obtention de la configuration, veuillez réessayer",
    batchResultSummary: "Total {total} enregistrements, {success} réussis, {fail} échoués",
    searchByCNCode: "Rechercher par code NC",
    downloadCSVTemplate: "Télécharger le modèle CSV",
    downloadXLSXTemplate: "Télécharger le modèle XLSX",
    previewReport: "Aperçu du rapport",
    to: "à",
    template: {
      saveTemplate: "Enregistrer le modèle",
      templateName: "Nom du modèle",
      namePlaceholder: "Veuillez saisir le nom du modèle",
      nameRequired: "Veuillez saisir le nom du modèle",
      nameTooLong: "Le nom du modèle ne peut dépasser 50 caractères",
      formIncomplete: "Veuillez compléter le formulaire avant d'enregistrer le modèle",
      saveSuccess: "Modèle enregistré avec succès",
      saveFailed: "Échec de l'enregistrement du modèle",
    },
  },
  tooltip: {
    cnCode: "Le code NC se compose de lettres, chiffres et tirets bas, jusqu'à 20 caractères",
  },
  progress: {
    title: "Calcul groupé",
    stages: {
      connecting: "Connexion en cours",
      connected: "Connecté",
      validating: "Validation en cours",
      validated: "Validé",
      calculating: "Calcul en cours",
      completed: "Calcul terminé",
    },
    close: "Fermer",
    regenerate: "Régénérer",
    addFactor: "Ajouter un facteur",
  },
  location: {
    noMatch: "Aucun résultat correspondant",
    enterKeyword: "Veuillez saisir un mot-clé",
  },
  plan: {
    trialExceeded: "Calculs d'essai dépassés ({count})",
    trialExpired: "Période d'essai expirée",
    monthlyExceeded: "Calculs mensuels dépassés ({count})",
    subscriptionExpired: "Période d'abonnement expirée",
  },
};
